import { WordType, WordTypeWithImages } from "../types";
import { SettingsState } from "../../settings/settingsSlice";
import { logResult, logSearch } from "../../analytics";
import PhonWord from "../../../ColorizationPart/Core/PhonWord";
import { createWordService } from "../../../lib";

export const searchWords = async (
  phonWord: PhonWord,
  settings: SettingsState
): Promise<WordTypeWithImages[]> => {
  // Create word service either with supabase or firebase
  const wordService = createWordService.createDefault(settings);

  const word = phonWord.GetWord();
  let words: WordType[] = [];
  const searchType =
    settings.helpLevel === 0
      ? "word"
      : settings.helpLevel === 1
      ? "phonetic"
      : "simple";

  let phonetic: string = "";
  if (searchType !== "word") {
    phonetic = phonWord.ToPhonString(searchType);
    if (phonetic.endsWith("ç")) {
      // search without ending 'e' (ç sound)
      words.push(
        ...(await wordService.getWordsWhereFieldEquals(
          searchType,
          phonetic.substring(0, phonetic.length - 1),
          { limit: settings.maxResults }
        ))
      );
    } else {
      // search with adding end 'e' (ç sound)
      words.push(
        ...(await wordService.getWordsWhereFieldEquals(
          searchType,
          phonetic + "ç",
          { limit: settings.maxResults }
        ))
      );
    }

    console.log("Search with type: " + searchType);
    console.log(
      "Search words for word = " + word + " and phonetic = " + phonetic
    );

    logSearch(word);
    words.push(
      ...(await wordService.getWordsWhereFieldLike(searchType, phonetic, {
        limit: Math.max(settings.maxResults - words.length, 1),
      }))
    );

    words.sort((w1, w2) =>
      w1.frequency > w2.frequency ? -1 : w1.frequency < w2.frequency ? 1 : 0
    );
  }

  let remainingResults = settings.maxResults - words.length;
  // this ensure we at least get the exact word if it exists
  if (remainingResults <= 0) {
    remainingResults = 1;
  }

  words.push(
    ...(await wordService.getWordsWhereFieldLike("word", word, {
      limit: remainingResults,
    }))
  );

  // remove duplicates
  words = words.filter(
    (v, i, a) => a.findIndex((v2) => v2.word === v.word) === i
  );

  // if we have exact word, put it first
  let exactWord: WordType | null = null;
  for (const w of words) {
    if (w.word === word) {
      exactWord = w;
      break;
    }
  }

  // Move words with phonetic match to the top
  let phoneticMatch: WordType[] = [];
  if (searchType !== "word") {
    phoneticMatch = words.filter(
      (w) => w[searchType] === phonetic && w.word !== word
    );
  }

  words = [
    ...phoneticMatch,
    ...words.filter((w) => w.word !== word && w[searchType] !== phonetic),
  ];
  if (exactWord !== null) {
    words = [exactWord, ...words];
  }

  // limit the number of results
  words = words.slice(0, settings.maxResults);

  const wordNames = words.map((w) => w.word);
  const imagesMap = await wordService.getImagesForWords(wordNames);

  // Attach images to each word
  let wordsWithImages: WordTypeWithImages[] = [];
  try {
    wordsWithImages = words.map((word) => ({
      ...word,
      images: imagesMap[word.word] || [],
    }));
  } catch (error) {
    console.error("Error attaching images to words:", error);
  }

  // add statistics of returned words
  wordsWithImages.forEach((w) => {
    logResult(w.word);
  });
  return wordsWithImages;
};
